import React from "react";
import moment from "moment";
import "moment/locale/hu";
import {
  MyHrPayrollMonthlyData,
  MyHrPayrollYearlyData,
} from "my-hr/components";
import { OcPageTransition } from "oc/components";
import { useOcClientState } from "oc/hooks";

interface MyHrPayrollDataPanelProps {
  contract: any; // Replace 'any' with the actual type if known
}

export const MyHrPayrollDataPanel = ({
  contract,
}: MyHrPayrollDataPanelProps) => {
  const currentYear = moment().format("YYYY");
  const currentMonth = moment().format("MM");

  const [selectedYear, setSelectedYear] = useOcClientState(
    "selectedPayrollYear",
    currentYear,
  );

  const [selectedMonth, setSelectedMonth] = useOcClientState(
    "selectedPayrollMonth",
    currentMonth,
  );

  const showBackToDate =
    selectedYear === currentYear && selectedMonth === currentMonth
      ? false
      : true;

  const handleSelectMonth = (month: string) => {
    setSelectedMonth(month);
  };

  const handleSelectYear = (year: string) => {
    setSelectedYear(year);
  };

  const handleBackToCurrent = () => {
    setSelectedYear(currentYear);
    setSelectedMonth(currentMonth);
  };

  const [showPaycard] = useOcClientState("showPaycard", false);

  return (
    <OcPageTransition>
      <div>
        <MyHrPayrollMonthlyData
          year={selectedYear}
          month={selectedMonth}
          contract={contract}
          onBack={handleBackToCurrent}
          showComponent={showBackToDate}
          onYearChange={handleSelectYear}
        />

        {!showBackToDate && !showPaycard && (
          <MyHrPayrollYearlyData
            contract={contract}
            onSelectMonth={handleSelectMonth}
            onSelectYear={handleSelectYear}
          />
        )}
      </div>
    </OcPageTransition>
  );
};

export default MyHrPayrollDataPanel;
